import { useParams, useRouter } from '@tanstack/react-router';

import { NavigationHeader } from '../../components/NavigationHeader/NavigationHeader';
import { Layout } from '../../components/Layout/Layout';
import { RequestDetails } from '../../components/RequestDetails/RequestDetails';
import { useWorkflow } from '../../workflow/hooks';
import { formatToShort } from '../../utils/dates';
import { getParams } from '../../utils/searchParams';
import { Page } from '../../components/Page/Page';

export const SubmittedDetails = () => {
  const router = useRouter();
  const { requestId } = useParams({
    from: '/$retailer/submitted-details/$requestId',
  });
  const { order, submittedRequests } = useWorkflow();

  const handleBack = () => router.history.back();

  const request = submittedRequests?.find((req) => req.id === requestId);

  if (!request) {
    // ToDo: Replace with actual design of the error state
    return <div>Something went wrong</div>;
  }

  const { deliveryType, shipments, items, packagingOption } = request;

  const replacementTokens = {
    orderNumber: order?.orderNumber ?? '',
    submittedDate: request.submitDate
      ? formatToShort(request.submitDate, getParams()?.locale)
      : '',
    deliveryMethodType: deliveryType,
    itemCount: `${items.length}`,
  };

  return (
    <Page>
      <NavigationHeader
        title={{
          langKey: 'Global.requestDetails.page.header',
        }}
        onClose={handleBack}
      />
      <Layout>
        <RequestDetails
          headerTitle={{
            langKey: 'Global.requestDetails.header.title',
            replacementTokens,
          }}
          headerSubtitle={{
            langKey: 'Global.requestDetails.header.subtitle',
            replacementTokens,
          }}
          data={{
            orderItems: order?.items ?? [],
            requestItems: items,
            deliveryType,
            deliveryMethod: { packagingOption },
            label: shipments[0] ? { url: shipments[0].labelUrl } : null,
            qrCode: shipments[0] ? { url: shipments[0].qrCodeUrl } : null,
            status: 'REQUEST_COMPLETE',
          }}
          replacementTokens={replacementTokens}
        />
      </Layout>
    </Page>
  );
};
